import { render, staticRenderFns } from "./require-recommend.vue?vue&type=template&id=75763d78&scoped=true&"
import script from "./require-recommend.vue?vue&type=script&lang=js&"
export * from "./require-recommend.vue?vue&type=script&lang=js&"
import style0 from "./require-recommend.vue?vue&type=style&index=0&id=75763d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75763d78",
  null
  
)

export default component.exports